<template>
  <div class="">
    <BaseGridTable class="no-border" v-if="table_exam && session" :tabledata="table_exam"
      @item-opened="$emit('item-opened')" v-bind="$attrs">
      <template v-slot:column_name="{ item }">
        <div class="patient-box" :class="{ 'anonymous': isJokerPatient(item) }" :data-exam-id="item.id">
          <a class="btn btn-secondary" href="#"
            @click.prevent.stop="isJokerPatient(item) ? $emit('do-assign', item) : toPatientDetails(item)">
            <span>{{ isJokerPatient(item) ? $t('noPatientSelected') : item.patient.fullName }}</span>
          </a>

          <p>
            <span>{{ formatDate(item.date) }}</span>

            <span v-if="showMutirao" style="display: flex; align-items: center;">
              <i v-show="item.referred > 0" class="fa" :class="item.referred == 1 ? 'fa-tint' : 'fa-check-circle-o'"
                aria-hidden="true"></i>
            </span>
          </p>

          <button class="btn btn-outline-secondary float-end" type="button" name="button" @click.prevent.stop="$emit('item-opened', {item: item})">
            {{ $t('user.exam') }}
            <IconArrowRight/>
          </button>
        </div>
      </template>

      <template v-slot:column_captures="{ item }">
        <lightgallery-vue class="image-info-box grid-wrap-between ease-all" :class="`zoom-level-${scale}`" :ref="`lGallery_${item.uuid}`"
          :id="`lightgallery_${item.uuid}`" :key="item.uuid" :settings="lightGallerySettings" :onInit="onInit"
          :onAfterOpen="extraCustomization" v-if="item.examImages.length > 0" @click.stop.prevent="prevent">

          <template v-for="(image, imageIndex) in item.examImages.filter((image, imageIndex) => imageIndex < 30)" :key="imageIndex">
            <a v-if="image.type.endsWith('VIDEO')" onclick="return false" class="thumbnail-box loading-eye" :class="image.type" :key="`video_${imageIndex}`" data-lg-size="1280-720"
              :data-video="getVideoSource(image)" data-download-url="" data-sub-html="<h4></h4><p></p>" :data-test="`anchorVideo_${imageIndex}`">
              <img class="lg-selector ease-all" src="@/assets/images/default-video2.png" alt="" @load="removeLoading($event)"/>
              <div class="thumb-actions">
                <div class="btn-group" role="group" aria-label="Thumb actions">
                  <button class="btn btn-download" type="button" name="button"
                          :data-test="`btnDownloadImage_${imageIndex}`"
                          @click.stop.prevent="doDownload(image, image.type.endsWith('VIDEO'))">
                    <i class="fa fa-download"></i>
                  </button>
                </div>
              </div>
            </a>

            <a v-else class="thumbnail-box loading-eye" onclick="return false" :class="image.type"
              :href="data_path + '/' + image.name" :data-test="`anchorImage_${imageIndex}`">

              <img class="lg-selector ease-all" :class="{ 'eyer2-image': image.eyerVersion > 0 }"
                    :src="thumb_path + '/' + image.name" alt="" @load="removeLoading($event)" />
              <div class="thumb-actions">
                <div class="btn-group" role="group" aria-label="Thumb actions">
                  <button class="btn btn-download" type="button" name="button"
                          :data-test="`btnDownloadImage_${imageIndex}`"
                          @click.stop.prevent="doDownload(image, image.type == 'STEREO')">
                    <i class="fa fa-download"></i>
                  </button>
                </div>
              </div>
            </a>
          </template>
        </lightgallery-vue>

        <div class="no-captures" v-else>
          <p>{{ $t('exam.noCaptures') }}</p>
        </div>
      </template>

      <template v-slot:column_content="{ item }">
        <div class="custom-box">
          <div class="">
            <template v-if="hasUnifiedReportFeature">
              <div class="btn-group btn-group-mark" :key="item.uuid" v-if="!item.unifiedExam?.type" :class="{ 'disabled': shouldDisableActionButtons(item) }">
                <p class="btn btn-outline-secondary" :data-test="`btnExamHasReport_${item.uuid}`">
                  <IconLamp/>
                  {{ $t('exam.examIs') }}
                </p>
                <button type="button" class="btn btn-outline-secondary" :class="{ 'disabled': shouldDisableActionButtons(item) }"
                   :data-test="`btnExamNoAlteration_${item.uuid}`" @click.stop.prevent="setAlteration('notAltered', item)" :disabled="shouldDisableActionButtons(item)">
                  <IconCheckBig/>
                  <span>{{ $t('exam.notAltered') }}</span>
                </button>
                <button type="button" class="btn btn-outline-secondary" :class="{ 'disabled': shouldDisableActionButtons(item) }"
                   :data-test="`btnExamHasAlteration_${item.uuid}`" @click.stop.prevent="setAlteration('altered', item)" :disabled="shouldDisableActionButtons(item)">
                  <IconWarningCircle/>
                  <span>{{ $t('exam.altered') }}</span>
                </button>
                <button type="button" class="btn btn-outline-secondary" :class="{ 'disabled': shouldDisableActionButtons(item) }"
                   :data-test="`btnExamNoQuality_${item.uuid}`" @click.stop.prevent="setAlteration('noQuality', item)" :disabled="shouldDisableActionButtons(item)">
                  <IconCross/>
                  <span>{{ $t('exam.noQuality') }}</span>
                </button>
              </div>

              <div class="report-info-box" v-else>
                <button class="btn btn-outline-secondary" :class="getAlterationClass(item.unifiedExam?.type)" type="button" name="button" v-if="!item.hasReport">
                  <IconPdfExam/>
                  {{ $t('tooltips.report') }}
                  <span>{{ $t(`exam.${item.unifiedExam?.type}`) }}</span>
                </button>

                <div class="dropdown" v-else>
                  <button class="btn btn-outline-secondary dropdown-toggle" :class="getAlterationClass(item.unifiedExam?.type)" type="button" data-bs-toggle="dropdown" aria-expanded="false" @click.prevent.stop="false">
                    <IconPdfExam/>
                    {{ $t('tooltips.report') }}
                    <span>{{ $t(`exam.${item.unifiedExam?.type}`) }}</span>
                  </button>
                  <ul class="dropdown-menu dropdown-exam-action">
                    <li class="dropdown-action-item">
                      <a class="dropdown-item" :data-test="`btnExamEditReport_${item.uuid}`" @click="goToReport(item)">{{ $t('exam.editReport') }}</a>
                    </li>
                    <li class="dropdown-action-item">
                      <a class="dropdown-item" :data-test="`btnExamDownload_${item.uuid}`" @click.stop.prevent="doDownload(item)">{{ $t('exam.downloadExam') }}</a>
                    </li>
                    <li class="dropdown-action-item">
                      <a class="dropdown-item" :data-test="`btnExamHasReport_${item.uuid}`" @click.stop.prevent="doDownloadPDF(item)">{{ $t('exam.downloadReport') }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </template>

            <template v-else-if="!isPaidService">
              <div class="btn-group btn-group-mark disabled blur" :key="item.uuid" @click.stop.prevent="toPlans()">
                <p class="btn btn-outline-secondary" :data-test="`btnExamHasReportDisabled_${item.uuid}`">
                  <IconLamp/>
                  {{ $t('exam.examIs') }}
                </p>
                <button type="button" class="btn btn-outline-secondary disabled" :data-test="`btnExamNoAlterationDisabled_${item.uuid}`" disabled>
                  <IconCheckBig/>
                  <span>{{ $t('exam.notAltered') }}</span>
                </button>
                <button type="button" class="btn btn-outline-secondary disabled" :data-test="`btnExamHasAlterationDisabled_${item.uuid}`" disabled>
                  <IconWarningCircle/>
                  <span>{{ $t('exam.altered') }}</span>
                </button>
                <button type="button" class="btn btn-outline-secondary disabled" :data-test="`btnExamNoQualityDisabled_${item.uuid}`" disabled>
                  <IconCross/>
                  <span>{{ $t('exam.noQuality') }}</span>
                </button>
              </div>
            </template>

            <template v-else>
              <div class="btn-group " role="group" aria-label="Default button group" v-if="(item.hasImage || item.hasReport) && item.hasNoAlteration">
                <button type="button" class="btn btn-outline-secondary" :disabled="isJokerPatient(item) ? true : !item.hasImage"
                  :data-title="$t('tooltips.download')" :data-test="`btnExamHasImage_${item.uuid}`" @click.stop.prevent="doDownloadExam(item)">
                  <IconDownload />
                  {{ $t('tooltips.download') }}
                </button>
                <button type="button" class="btn btn-outline-secondary" :disabled="isJokerPatient(item)"
                  :data-title="$t('tooltips.report')" :data-test="`btnExamHasReport_${item.uuid}`" @click.stop.prevent="checkDownloadOrRoute(item)">
                  <IconPdf />
                  {{ $t('tooltips.report') }}
                </button>
              </div>
            </template>

            <div class="ai-box" style="align-self: flex-end;" v-if="item.scoreResult && item.scoreResult.doubleCircle" :data-title="$t('exam.iaText')">
              <p>AI</p>
              <span :class="item.scoreResult.odStatus ?? ''"></span>
              <span :class="item.scoreResult.osStatus ?? ''"></span>
            </div>
            <div class="ai-box" v-if="item.scoreResult && !item.scoreResult.doubleCircle" :data-title="$t('exam.iaText')">
              <p>AI </p>
              <span :class="item.scoreResult.odStatus ?? ''"></span>
            </div>

            <div class="alteration-list" v-if="item?.scoreResult?.alterationText">
              <template v-for="text of item.scoreResult.alterationText">
                <b v-if="text === 'mcRASE2_c1'">
                  {{ $t(text) }}
                </b>
                <span v-else>
                  {{ $t(text) }}
                </span>
              </template>
            </div>

            <button class="btn btn-outline-secondary btn-share" v-if="!isSpecialist && !isJokerPatient(item)" type="button" name="button"
              data-test="btnPatientShare" @click.prevent.stop="shareInformation(item)">
              <IconShare />
              <span>{{ $t('externalPatient.shareSimple') }}</span>
            </button>
          </div>

          <button class="btn btn-outline-secondary float-end" type="button" name="button" @click.prevent.stop="$emit('item-opened', {item: item})">
            {{ $t('exam.examAccess') }}
          </button>
        </div>
      </template>

      <!-- <template v-slot:column_ai="{item}">

      </template> -->
    </BaseGridTable>

    <teleport to="body">
      <BasePatientAccessInfoOffcanvas ref="offcanvasPatientAccessInfo" />
    </teleport>
  </div>
</template>

<style lang="scss" scoped>
.custom-box {
  width:                              100%;
  flex:                               1;
  > div {
    display:                          flex;
    gap:                              15px;
    flex:                             1;
  }

  > .btn {
    margin-left:                      auto;
    &:hover,
    &:focus,
    &:active,
    &.active {
      color:                          var(--Brand-Primary);
      background:                     var(--Shades-BG);
    }
  }
}

.fa {
  font-size:                          22px !important;
  align-self:                         center;
  color:                              var(--Brand-Primary, #1B294A);
}

.image-info-box {
  gap:                                10px;

  &.grid-wrap-between {
    justify-content:                  flex-start;
    grid-template-columns:            repeat(auto-fill, 32.7%) !important;
    gap:                              5px;

    &.zoom-level-1 {
      grid-template-columns:          repeat(auto-fill, 9.63%) !important;
    }

    &.zoom-level-2 {
      grid-template-columns:          repeat(auto-fill, 16.33%) !important;
    }

    &.zoom-level-3 {
      grid-template-columns:          repeat(auto-fill, 24.65%) !important;
    }

    &.zoom-level-4 {
      grid-template-columns:          repeat(auto-fill, 49.75%) !important;
    }
  }

  .thumbnail-box {
    margin:                           0;
    height:                           100%;

    img {
      @include                        border_radius(0);
      width:                          100%;
      height:                         100%;
      aspect-ratio:                   87 / 74;
      background-size:                cover;

      &.eyer2-image {
        background-size:              unset;
      }
    }
  }
}

// TODO bruno: rever necessidade de todos os atributos
.thumbnail-box {
  position:                           relative;

  .thumb-actions {
    position:                         absolute;
    bottom:                           8px;
    right:                            8px;
    z-index:                          10;
    width:                            auto;

    .btn-group {
      display:                        inline-flex;

      .btn {
        @include                      border_radius(90px);
        display:                      flex;
        align-items:                  center;
        justify-content:              center;
        min-width:                    32px !important;
        min-height:                   20px;
        padding:                      4px 15px !important;
        border:                       1px solid rgba(13, 110, 253, 0.1);

        &:hover {
          i {
            color:                    rgb(13, 110, 253);
          }
        }
        i.fa-download {
          font-size:                  13px !important;
          line-height:                1;
          width:                      12px;
          height:                     12px;
          vertical-align:             middle;
        }
      }

      .btn-download {
        min-width:                    24px !important;
        min-height:                   24px !important;
        padding:                      4px 6px !important;
      }
    }
  }
}

.rectract {
  .image-info-box.grid-wrap-between {
    grid-template-columns:             repeat(auto-fill, 24%) !important;
  }
}

.btn-group-mark.disabled p.btn.btn-outline-secondary {
  &,
  &:hover,
  &:focus {
    background:                        transparent !important;
    border:                            0;
  }
}

.btn-share {
  font-size:                           var(--font-size-10);
  display:                             flex;
  flex-direction:                      row;
  gap:                                 5px;
  max-height:                          32px;
  padding:                             6px 16px;
}

@media (max-width: 500px) {
  .retract .image-info-box.grid-wrap-between,
  .image-info-box.grid-wrap-between {
    grid-template-columns:             repeat(auto-fill, 100%) !important;
  }
}

@media (max-width: 991px) {
  .custom-box {
    justify-content:                   center;
    flex-wrap:                         wrap;

    > div {
      flex:                            unset;
      flex-wrap:                       wrap;
    }
    > .btn {
      margin-left:                     unset;
    }
  }

  .image-info-box.grid-wrap-between {
    justify-content:                   space-between;
  }
}

@media screen and (min-width: 501px) and (max-width: 991px) {
  .retract .image-info-box.grid-wrap-between,
  .image-info-box.grid-wrap-between {
    grid-template-columns:             repeat(auto-fill, 48%) !important;
  }
}

@media screen and (min-width: 992px) and (max-width: 1365px) {
  .image-info-box.grid-wrap-between {
    grid-template-columns:             repeat(auto-fill, 32%) !important;
  }
}
</style>

<script>
import { useUserStore } from '@/store/user'
import lgAutoplay from 'lightgallery/plugins/autoplay';
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgVideo from 'lightgallery/plugins/video';
import lgZoom from '@/assets/dependencies/lightGallery/plugins/zoom';

export default {
  name: 'ExamGridList',
  props: ['table_exam', 'thumb_path', 'data_path', 'scale'],
  data: () => ({
    loading: false,
    alert: {
      message: null,
      class: null
    },
    session: null,
    lightGallerySettings: {
      showZoomInOutIcons: true,
      actualSize: false,
      autoplayVideoOnSlide: true,
      speed: 300,
      licenseKey: 'CE440F6C-34CE4C2A-86065648-48895C83',
      plugins: [],
      showMutirao: false
    },
    showMutirao: false,
    lightGallery: null,
    showActionButtons: false,
    hasUnifiedReportFeature: false,
    isSpecialist: null,
  }),
  created() {
    this.lightGallerySettings.plugins = [lgAutoplay, lgFullscreen, lgThumbnail, lgVideo, lgZoom]
  },
  mounted() {
    const userStore = useUserStore()
    this.session = userStore.sessionInfo
    this.showMutirao = this.session.features.includes('mutirao')
    this.hasUnifiedReportFeature = this.session.features.includes('unifiedReport')
    this.isSpecialist = this.session.isSpecialist
  },
  methods: {
    extraCustomization() {
      let self = this

      $(".lg-download").off("click").on("click", function (event) {
        event.preventDefault();
        console.log('this.href: ',this.href)
        let examDataUUID = this.href.split('/').pop()
        console.log('this.href: ',examDataUUID)
        let item = { uuid: examDataUUID }
        self.doDownload(item)
      })

      $('.lg-fullscreen.lg-icon').click();
    },
    async doDownload(item, isVideo) {
      console.log('item do download', item);
      this.loading = true
      NProgress.start()
      try {
        let params = {}
        if (item.id)
          params['id'] = item.id

        if (item.uuid)
          params['uuid'] = item.uuid

        let response = await this.$examDataService.download(params)

        fetch(response.downloadURL)
          .then(res => res.blob())
          .then(blob => {
            let objectURL = URL.createObjectURL(blob);
            let el = document.createElement('a');
            el.href = objectURL;
            el.download = isVideo ? `${item.uuid}.mp4` : `${item.uuid}.jpeg`;
            document.body.appendChild(el);
            el.click();
            document.body.removeChild(el);
            URL.revokeObjectURL(objectURL);
          });
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      }
      NProgress.done(true)
      this.loading = false
    },
    removeLoading(event) {
      let parentNode = event.target.parentElement.classList;
      let currentlyNode = event.target.classList;

      this.$nextTick(() => {
        currentlyNode.add('loaded')
        parentNode.remove('loading-eye')
      });
    },
    allowedImages(image) {
      return !image.endsWith('VIDEO')
    },
    prevent() {
      // function to avoid click to expand and enter in exam details
      console.log('prevent');
    },
    formatDate(date) {
      return moment(date).format(this.$i18n.t('dateTimeFormat'))
    },
    toPatientDetails(item) {
      this.$router.push({ name: 'patient-show', params: { patientID: item.patient.id }, query: { tab: 'data' } })
    },
    isJokerPatient(item) {
      return item.patient.uuid == this.session.currentClinic.jokerPatientUuid
    },
    shouldDisableActionButtons(item) {
      return this.isJokerPatient(item) || !item.hasImage
    },
    doDownloadExam(exam){
      try {
        NProgress.start()
        this.$examService.download(exam.id)
      } catch (err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      }
      NProgress.done(true)
    },
    async checkDownloadOrRoute(item){
      if (item.hasReport){
        await this.doDownloadPDF(item)
      } else {
        this.$router.push({ name: 'exam-show', params: { examID: item.id }, query: { tab: 'report' } })
      }
    },
    async doDownloadPDF(item){
      let params = {
        id: item.id,
      }
      try {
        let response = await this.$reportService.getList(params);

        if (response.result.length > 0) {
          let theReport = response.result[response.result.length - 1]
          let params = {
            id: theReport.id
          }
          this.$reportService.generateReport(params);
        }

      } catch(err) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
        // this.alert = this.$message.alert(this, 'request_error', 'danger')
      }
    },
    async setAlteration(value, item) {
      let params = {
        examId: item.id,
        type: value
      }

      this.loading = true
      NProgress.start()
      try {
        let response = await this.$examService.updateUnifiedExam(params)
        console.log('response setAlteration', response.exam);

        response.exam.unifiedExam.type == 'altered' ? this.goToReport(response.exam) : this.$emit('do-reload')
      } catch (e) {
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
      } finally {
        NProgress.done(true)
        this.loading = false
      }

      console.log('item', item);
    },
    getVideoSource(item) {
      let result = {
        "source": [
          {
            "src": `${this.data_path}/${item.name}?autoplay=1`,
            "type": "video/mp4"
          }
        ],
        "attributes": {
          "preload": false,
          "playsinline": false,
          "controls": true,
          "loop": true
        }
      }

      return JSON.stringify(result)
    },
    onInit(detail) {
      this.lightGallery = detail.instance;
    },
    goToReport(item) {
      this.$router.push({ name: 'exam-show', params: { examID: item.id }, query: { tab: 'report', fromExamList: true } })
      // this.$router.push({ name: 'report', params: { examID: item.id, patient: item.patient } })
    },
    getAlterationClass(alteration) {
      if (typeof alteration === 'string') {
        if (alteration === 'altered') {
          return 'has-alteration'
        } else if (alteration === 'notAltered') {
          return 'no-alteration'
        } else if (alteration === 'noQuality') {
          return 'no-quality'
        }
      }
      return ''
    },
    async shareInformation(item) {
      const ok = await this.$refs.offcanvasPatientAccessInfo.show({
        patient: item.patient
      })
      if (ok) {
        NProgress.done(true)
      }
    },
    toPlans() {
      this.$router.push('/plans/')
    },
  }
}
</script>
